var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import { Checkbox, customMap, createComponent } from '../../dependencies';
var CheckboxGroup = Checkbox.Group;
var checkboxGroupMap = customMap(function (_ref, _ref2) {
  var _ref2$input = _ref2.input,
      onChange = _ref2$input.onChange,
      _onBlur = _ref2$input.onBlur,
      _onFocus = _ref2$input.onFocus,
      _ref2$input$value = _ref2$input.value,
      value = _ref2$input$value === undefined ? [] : _ref2$input$value;

  var defaultValue = _ref.defaultValue,
      mapProps = _objectWithoutProperties(_ref, ['defaultValue']);

  return _extends({}, mapProps, {
    onChange: onChange,
    onFocus: function onFocus() {
      _onFocus();
    },
    onBlur: function onBlur() {
      _onBlur();
    },
    value: !value ? defaultValue : value
  });
});
export default createComponent(CheckboxGroup, checkboxGroupMap);